export default `
query getFilterPagesSeoDescData($filters: ProductAttributeFilterInput!) {
	products(filter: $filters) {
		mw_seo_category_data {
			meta_title
			description
		}
	}
}`;
